import type { ColorName } from '@emotion/react';
import { ActionList, Dialog } from 'design-system/components';
import { useBoolean } from 'hooks/useBoolean';
import type React from 'react';
import { strings } from 'strings';

import { type ContentProps as BaseContentProps, Content } from './Content';
import {
  isSupportedFilter,
  statusColors,
  statusIcons,
  taskDate,
  taskTitle,
} from './internal';

export type ContentProps = Omit<BaseContentProps, 'onClose'>;

export interface ItemProps extends ContentProps {
  showContent?: boolean;
  smallItems?: boolean;
  showName?: boolean;
  backgroundColor?: ColorName;
}

export const Item: React.FC<ItemProps> = ({
  task,
  onNoteAdd,
  onSelect,
  showContent,
  smallItems,
  showName = false,
  backgroundColor,
}) => {
  const open = useBoolean(false);

  const status = task.status;
  const title = taskTitle(task, showName);
  const date = taskDate(task);

  const supportedStatus = isSupportedFilter(status);
  const statusColor = supportedStatus ? statusColors[status] : undefined;
  const statusIcon = supportedStatus ? statusIcons[status] : undefined;

  const onPress = showContent ? open.setTrue : onSelect;

  return (
    <>
      <ActionList.Item
        id={task.id}
        onPress={onPress}
        title={title || strings.DisplayNotFound}
        subTitle={date || ''}
        statusIcons={[
          {
            name: statusIcon,
            color: statusColor,
          },
        ]}
        small={smallItems}
        backgroundColor={backgroundColor}
      />
      {showContent ? (
        <Dialog
          borderColor={statusColor}
          title={title || strings.DisplayNotFound}
          isOpen={open.value}
          onRequestClose={open.setFalse}
        >
          <Content
            task={task}
            onNoteAdd={onNoteAdd}
            onSelect={onSelect}
            onClose={open.setFalse}
            isDialog={showContent}
          />
        </Dialog>
      ) : null}
    </>
  );
};
